import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { InputAppearance, IntegratorRoot, TextArea, TextInput, ThemeProvider } from '@volkswagen-onehub/components-core';
import React from 'react';
import ReactDOM from 'react-dom';

@Component({
    selector: 'app-vwsa-text-input',
    template: '',
    providers: [{ provide: NG_VALUE_ACCESSOR, multi: true, useExisting: VWSATextInputComponent }] // required for using this control in forms
})
export class VWSATextInputComponent implements AfterViewInit, OnChanges, OnDestroy, ControlValueAccessor {
    //https://lsg-auth.prodworksngwsa.de/components-core/?path=/docs/components-textinput--text-input    
    @Input() label = '';
    @Input() value = '';
    @Input() isRequired = 'false';
    @Input() disabled = 'false';
    @Input() inputMode = 'text';
    @Input() readonly = 'false';
    @Input() validationMessage = '';
    @Input() rows = 1;
    @Input() maxLength = 500;
    @Input() placeholder = '';

    @Output() valueChange = new EventEmitter<string>();
    @Output() onblur = new EventEmitter<void>();

    constructor(private hostRef: ElementRef) {
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    ngOnChanges(changes: SimpleChanges): void {
        //console.log('VWSATextInputComponent.ngOnChanges', changes);
        this.render();
    }

    ngAfterViewInit(): void {
        //console.log('VWSATextInputComponent.ngAfterViewInit');
        setTimeout(() => { this.render(); }, 50);
    }

    ngOnDestroy(): void {
        //console.log('VWSATextInputComponent.ngOnDestroy');
        //removing this for because it causes delays when navigating.
        //find a way to call it async so it doesn't delay navigation.        
        //setTimeout(() => { ReactDOM.unmountComponentAtNode(this.hostRef.nativeElement); }, 50);
    }

    private render() {
        //console.log('VWSATextInputComponent.render');
        if (this.rows == 1) {
            ReactDOM.render(
                <ThemeProvider>
                    <TextInput
                        appearance={
                            this.disabled == 'true' ? InputAppearance.Disabled :
                                this.readonly == 'true' ? InputAppearance.ReadOnly :
                                    this.validationMessage.length > 0 ? InputAppearance.Error : InputAppearance.Default
                        }
                        label={this.label}
                        value={this.value || ''}
                        placeholder={this.placeholder}
                        message={this.validationMessage.length > 0 ? this.validationMessage : null}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        required={this.isRequired == 'true'}
                    />
                </ThemeProvider>
                , this.hostRef.nativeElement);
        }
        else {
            ReactDOM.render(
                <IntegratorRoot>
                    <ThemeProvider>
                        <TextArea
                            appearance={
                                this.disabled == 'true' ? InputAppearance.Disabled :
                                    this.readonly == 'true' ? InputAppearance.ReadOnly :
                                        this.validationMessage.length > 0 ? InputAppearance.Error : InputAppearance.Default
                            }
                            label={this.label}
                            value={this.value}
                            rows={this.rows}
                            message={this.validationMessage.length > 0 ? this.validationMessage : null}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            required={this.isRequired == 'true'}
                        />
                    </ThemeProvider>
                </IntegratorRoot>
                , this.hostRef.nativeElement);
        }
    }

    public handleChange(event: any): void {
        //console.log('VWSATextInputComponent.handleChange');
        this.value = event.target.value.substring(0, this.maxLength);
        this.valueChange.emit(this.value);
        this.onChange(this.value);
        this.render();
    }

    public handleBlur(event: any): void {
        this.onblur.emit();
    }

    // implementing ControlValueAccessor - required for using this control in forms
    onChange = (value: string): void => {
        //console.log('VWSATextInputComponent.onChange');
    };

    onTouched = (): void => {
        //console.log('VWSATextInputComponent.onTouched');
    };

    writeValue(value: string): void {
        //console.log('VWSATextInputComponent.writeValue', value);
        this.value = value;
        this.render();
    }

    registerOnChange(onChange: any): void {
        //console.log('VWSATextInputComponent.registerOnChange');
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any): void {
        //console.log('VWSATextInputComponent.registerOnTouched');
        this.onTouched = onTouched;
    }

    setDisabledState(disabled: boolean): void {
        //console.log('VWSATextInputComponent.setDisabledState');
        this.disabled = disabled == true ? 'true' : 'false';
        this.render();
    }

    validate(control: AbstractControl): ValidationErrors | null {
        //console.log('VWSATextInputComponent.validate');
        const value = control.value;
        if (!value) {
            return {
                required: {
                    value
                }
            };
        } else {
            return null; // validation ok
        }
    }
}
